import React, {useEffect} from 'react'
import { Brands } from '../../components'

const Showcase = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

  }, []);
  return (

<>
      <section className={`bg-black px-8 pt-40 md:pt-60 -mt-[1px] text-center  lg:px-16 font-semibold md:pb-10`}>
        <div className="md:w-[70%] mx-auto mb-10">
        <h2 className={`text-[32px] md:text-[64px] text-white leading-[33px] md:lg:leading-[74.56px]`}>This Showcase consists of
          <span className={`italic font-normal `}>&nbsp; Personal </span> &nbsp;and 
          <span className={`italic font-normal`}>&nbsp;Commissioned </span>&nbsp;projects.
        </h2>
        </div>
        <div className="h-[0.5px] bg-[#f5f5f5]" />
      </section>
     
   

      <Brands styles={`md:pb-[80px] `}/>

  
      <section className="bg-black px-8 py-10 -mt-[1px] lg:px-16">
        <div className="h-[0.5px] bg-[#f5f5f5]" />
      </section>

    
      
      </>  
  )
}

export default Showcase